import { render, staticRenderFns } from "./messageGroupUserForm.vue?vue&type=template&id=b961e0b8&"
import script from "./messageGroupUserForm.vue?vue&type=script&lang=js&"
export * from "./messageGroupUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports